import React from 'react';

import './Footer.css';

export default function Footer() {
	return (
		<footer className='copy-footer'>
			Copyright &copy; 2019 Glaiza Wagner and Zacharia Lutz
		</footer>
	)
}